export default __webpack_public_path__ + "7bbceb0191653f54ac6650035afae216.png";